module.exports = __webpack_public_path__ + "img/ct-cg-horizontal.2d65623c.png";